import React from 'react';
import { useApp } from './context';
import { Empty, LoadingState, PageTitle } from './ui';
import { useRFQBuilder } from './rfq/useRFQBuilder';
import { RequirementFields } from './rfq/RequirementFields';
import { DeliveryFields } from './rfq/DeliveryFields';
import { RFQReview, RFQSummary, RFQSuccess } from './rfq/RFQReview';
import { RFQNavigation, RFQSteps } from './rfq/RFQNavigation';

const RFQForm = ({ model }) => <div className="rfq-layout">
  <section>
    <RFQSteps step={model.step} />
    <form onSubmit={model.submit}>
      {model.step === 0 && <RequirementFields draft={model.draft} sample={model.form.sample}
        setSample={value => model.setField('sample', value)} setQuantity={model.setQuantity} removeItem={model.removeItem} />}
      {model.step === 1 && <DeliveryFields bind={model.bind} user={model.user} files={model.files} setFiles={model.setFiles} />}
      {model.step === 2 && <RFQReview user={model.user} draft={model.draft} form={model.form} files={model.files} />}
      {model.error && <div data-testid="rfq-error" role="alert" className="notice error">{model.error}</div>}
      <RFQNavigation step={model.step} setStep={model.setStep} validItems={model.validItems} user={model.user} busy={model.busy} />
    </form>
  </section>
  <RFQSummary draft={model.draft} />
</div>;

const RFQFlow = () => {
  const model = useRFQBuilder();
  if (model.done) return <RFQSuccess requests={model.done} />;
  if (!model.draft.length) return <Empty title="What are you sourcing?"
    text="Select products from the catalog or add SKUs through quick order." to="/catalog" label="Explore the catalog" />;
  return <RFQForm model={model} />;
};

export default function RFQBuilder() {
  const { loading } = useApp();
  return <div className="container rfq-page">
    <PageTitle eyebrow="BETTER SOURCING STARTS HERE" title="Request a quotation.">
      Your requirements. The right supplier. A quote that fits.
    </PageTitle>
    {loading ? <LoadingState /> : <RFQFlow />}
  </div>;
}